import React,{useState, useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import summaryexpensereportaction from '../../../context/action/report/summaryexpensereportaction';
import Summary_expense_table from './summary_expense_table';

const Expense_Report = () => {
    const { initState, initDispatch, clear } = useContext(GlobalContext);
        
    const [from, setfrom] = useState("");
    const [to, setto] = useState("");
    const [table_type, settable_type] = useState("");

    const [error, seterror] = useState(false);
    const [error1, seterror1] = useState(false);
    return (
        <div className="min-h-screen bg-slate-50 p-6 md:p-8">
            {/* Page Header */}
            <div className="flex items-center justify-between mb-8">
                <div>
                <h1 className="text-2xl font-bold text-slate-800">ڕاپۆرت ← خەرجی</h1>
                <p className="text-sm text-slate-400 mt-0.5">داتا و وردەکاری خەرجیەکان </p>
                </div>
            </div>
            {/* Add New Category Form */}
            <div className="bg-white border border-slate-100 rounded-xl p-6 mb-6 shadow-sm">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 items-end">
                    <div className="w-full">
                        <label
                            className={
                                error
                                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                                : "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            for="from"
                        >
                            لە بەرواری{" "}
                        </label>
                        <input
                            className={
                                error
                                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="from"
                            type="date"
                            value={from}
                            onChange={(val) => setfrom(val.target.value)}
                            onFocus={() => seterror(false)}
                        />
                    </div>
                    <div className="w-full">
                        <label
                            className={
                                error1
                                ? "block text-sm font-medium text-red-500 mb-1 text-right"
                                : "block text-sm font-medium text-slate-500 mb-1 text-right"
                            }
                            for="to"
                        >
                            بۆ بەرواری{" "}
                        </label>
                        <input
                            className={
                                error1
                                ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                                : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                            }
                            id="to"
                            type="date"
                            placeholder=""
                            value={to}
                            onChange={(val) => setto(val.target.value)}
                            onFocus={() => seterror1(false)}
                        />
                    </div>
                </div>
            </div>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4 sm:gap-6">
                <div
                    className="cursor-pointer rounded-lg bg-white shadow-md 
                    transition-all duration-200 hover:shadow-lg"
                    onClick={()=>{
                        if(!from || from == "") {
                            seterror(true);
                            return false;
                        }
                        if(!to || to == "") {
                            seterror1(true);
                            return false;
                        }
                        summaryexpensereportaction(from,to)(initDispatch)(clear)(settable_type);
                    }}
                >
                    <div className="p-4 sm:p-6">
                    <h5 className="mb-2 text-lg sm:text-xl font-medium text-gray-900">
                        پوختە
                    </h5>
                    <div className="pt-4 border-t text-sm text-gray-600">
                        لە بەرواری , بۆ بەرواری
                    </div>
                    </div>
                </div>
            </div>
            { table_type == "summary_expense_report" ?<Summary_expense_table />:null}
        </div>
    )
}

export default Expense_Report